/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagResponseItem } from './tagResponseItem';

export interface ManagementKeywordResponse { 
    id?: string;
    text?: string;
    sources?: Array<ManagementKeywordResponse.SourcesEnum>;
    tags?: Array<TagResponseItem>;
}
export namespace ManagementKeywordResponse {
    export type SourcesEnum = 'GRID' | 'FAXAL' | 'INOREADER' | 'DEFAULT' | 'COPY' | 'NEW_GROUP' | 'CLIPS' | 'MANUAL' | 'IMPORT' | 'FACEBOOK';
    export const SourcesEnum = {
        GRID: 'GRID' as SourcesEnum,
        FAXAL: 'FAXAL' as SourcesEnum,
        INOREADER: 'INOREADER' as SourcesEnum,
        DEFAULT: 'DEFAULT' as SourcesEnum,
        COPY: 'COPY' as SourcesEnum,
        NEWGROUP: 'NEW_GROUP' as SourcesEnum,
        CLIPS: 'CLIPS' as SourcesEnum,
        MANUAL: 'MANUAL' as SourcesEnum,
        IMPORT: 'IMPORT' as SourcesEnum,
        FACEBOOK: 'FACEBOOK' as SourcesEnum
    };
}